import React from "react";
import { FontAwesome } from "../../FontAwesome";
import { IFlexProps } from "../../Flex";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  containerProps?: IFlexProps;
}

// == Constants ============================================================

const DEFAULT_PROPS = {};

// == Component ============================================================

export const MapMarkerIcon = ({ containerProps, ...rest }: IProps) => {
  return (
    <FontAwesome
      containerProps={containerProps}
      data-testid="map-marker-alt"
      icon="map-marker-alt"
      {...rest}
    />
  );
};

MapMarkerIcon.defaultProps = DEFAULT_PROPS;

// == Styles ===============================================================
